import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Sidebar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/image.png";
import { getColorFromName } from "../../utils/getColor";
import { useDispatch, useSelector } from "react-redux";
import {
  clearNotification,
  handleCurrentUserMessages,
  handleUnreadChatNotifications,
  updateChatCount,
  updateRenderChats,
} from "../../redux/chatData";
import apiServiceHandler from "../../service/apiService";
import { updateUserDetails } from "../../redux/userData";
import { ClipboardCheck, ClipboardPen, NotebookPen } from "lucide-react";

import {
  onSnapshot,
  doc,
  collection,
  getDocs,
  updateDoc
} from "firebase/firestore";
import { firestore, storage } from "../../firebase";
import { handleUnreadCourseNotifications } from "../../redux/coursesData";
import { handleUnreadGroupNotifications } from "../../redux/groupData";
//End of the code here

const Sidebar = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails")) || null;
  const isAdmin = userDetails?.admin;
  const refreshUserData = useSelector(
    (state) => state.userData.refreshUserData
  );
  const location = useLocation();
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentUserData, setCurrentUserData] = useState({});
  const [notifications, setNotifications] = useState([]);
  const [groupNotifications, setGroupNotifications] = useState([])
  const [courseNotifications, setCourseNotifications] = useState([])
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const hasNewChat = useSelector((state) => state.chatData.hasNewChat);
  const renderChats = useSelector((state) => state.chatData.renderChats);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
    dispatch(handleCurrentUserMessages([]));
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getCurrentUser = async () => {
    try {
      const response = await apiServiceHandler("GET", "api/user/profile", {});
      // console.log(response, 'response is here..');
      if (response.success && response.data) {
        dispatch(updateUserDetails(response.data));
        setCurrentUserData(response.data);
      }
    } catch (error) {
      console.error("Error getting getCurrentUser:", error);
    }
  };

  useEffect(() => {
    getCurrentUser();
  }, [refreshUserData]);

  const getAllChats = async () => {
    try {
      const response = await apiServiceHandler("GET", "api/chat/list", {});

      if (response.status) {
        console.log(response, "response is here..");
        const data = response.data[0];
        dispatch(updateChatCount(data?.total));
      }
    } catch (error) {
      console.error("Error getting users:", error);
    }
  };

  useEffect(() => {
    if (renderChats) {
      getAllChats();
    }
    dispatch(updateRenderChats(false));
  }, [renderChats]);


  useEffect(() => {
    if (!userDetails?._id) return; // Ensure userDetails._id exists
  
    // References to the user's notifications documents
    const personalNotificationsRef = doc(firestore, "notification", userDetails._id);
    const groupNotificationsRef = doc(firestore, "notifs", userDetails._id);
    const courseNotificationsRef = doc(firestore, "coursenotifications", userDetails._id);
  
    // Function to handle updates for a specific reference
    const handleNotificationsUpdate = (docSnapshot, setState, logMessage) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        const notifications = data.notifications || [];
        const unreadNotifications = notifications.filter((notification) => !notification.read);
        if (setState === setNotifications) {
          dispatch(handleUnreadChatNotifications(unreadNotifications));
        } else if (setState === setCourseNotifications) {
          dispatch(handleUnreadCourseNotifications(unreadNotifications));
        } else if (setState === setGroupNotifications) {
          dispatch(handleUnreadGroupNotifications(unreadNotifications));
        }
        setState(unreadNotifications);
      } else {
        setState([]);
        console.log("No notifications document found for user.");
      }
    };
  
    // Listen for real-time updates on both notification documents
    const unsubscribePersonal = onSnapshot(personalNotificationsRef, (docSnapshot) => {
      handleNotificationsUpdate(docSnapshot, setNotifications, "Unread personal notifications data value is here");
    });
  
    const unsubscribeGroup = onSnapshot(groupNotificationsRef, (docSnapshot) => {
      handleNotificationsUpdate(docSnapshot, setGroupNotifications, "Unread group notifications data value is here");
    });

    const unsubscribeCourse = onSnapshot(courseNotificationsRef, (docSnapshot) => {
      handleNotificationsUpdate(docSnapshot, setCourseNotifications, "Unread personal notifications data value is here");
    });
  
    // Cleanup function
    return () => {
      unsubscribePersonal();
      unsubscribeGroup();
      unsubscribeCourse();
      console.log(`Unsubscribed from notifications for user ID: ${userDetails._id}`);
    };
  }, [userDetails?._id]);

  // const markAllNotificationsAsRead = async () => {
  //   try {
  //     const notifsCollectionRef = collection(firestore, "notifs");
  
  //     const snapshot = await getDocs(notifsCollectionRef);
  
  //     const updatePromises = snapshot.docs.map(async (docSnapshot) => {
  //       const docRef = docSnapshot.ref; // Reference to the document
  //       const data = docSnapshot.data(); // Get document data
  
  //       if (data.notifications && Array.isArray(data.notifications)) {
  //         const updatedNotifications = data.notifications.map((notification) => ({
  //           ...notification,
  //           read: true,
  //         }));
  
  //         await updateDoc(docRef, { notifications: updatedNotifications });
  //       }
  //     });
  
  //     await Promise.all(updatePromises);
  
  //     console.log("All notifications marked as read.");
  //   } catch (error) {
  //     console.error("Error updating notifications:", error);
  //   }
  // };
  
  // useEffect(() => {
  //   markAllNotificationsAsRead()
  // }, [])
  
  

  return (
    <div className="layout__sidebar">
      <div className="sidebar is-visible">
        <div className="sidebar__content">
          <div className="sidebar__header">
            <Link to="/">
              <div style={{ height: "80px", width: "200px" }}>
                <div className="sidebar__logo">
                  <img
                    className="logo_img"
                    // src="https://app.jurni.io/img/logo.d5dba06e.png"
                    src={Logo}
                    alt=""
                  />
                </div>
              </div>
            </Link>
          </div>
          <div className="sidebar__body">
            <div className="sidebar__tagline">
              {/*
              <div className="course-name">
                <div className="default-slot">
                  <div className="default-slot__content">ȷurnı Showcase</div>
                </div>
              </div>
              <div className="course-desc">
                <div className="default-slot">
                  <div className="default-slot__content">
                    Welcome to the ȷurnı platform pre-launch showcase!
                    <br></br>
                  </div>
                </div>
              </div>
              */}
            </div>
            <div className="sidebar__menu">
              <div className="menu">
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(updateRenderChats(true));
                    navigate("/daily-work");
                  }}
                  className={`menu-item ${
                    location.pathname.split("/").includes("daily-work")
                      ? "active"
                      : ""
                  }`}
                >
                  <span className="menu-item__icon">
                    {/* <svg
                      viewBox="0 0 18 20"
                      fill={location.pathname.split("/").includes("daily-work") ? "#000" : "#fff"}
                      xmlns="http://www.w3.org/2000/svg"
                      className="menu-icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <path d="M16.75 19.5h-4.5c-.69 0-1.25-.56-1.25-1.25v-4.5a1 1 0 00-1-1H8a1 1 0 00-1 1v4.5c0 .69-.56 1.25-1.25 1.25h-4.5C.56 19.5 0 18.94 0 18.25V8.707C0 7.556.527 6.47 1.43 5.76L8.535.16a.752.752 0 01.928 0l7.107 5.6A3.75 3.75 0 0118 8.706v9.544c0 .69-.56 1.25-1.25 1.25z"></path>
                    </svg> */}
                    {location.pathname.split("/").includes("daily-work") ? (
                      <ClipboardPen style={{ color: "#000" }} />
                    ) : (
                      <ClipboardPen style={{ color: "#fff" }} />
                    )}
                  </span>
                  <div class="menu-item__label">The Daily Work</div>
                </Link>
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(updateRenderChats(true));
                    navigate("/courses");
                  }}
                  className={`menu-item ${
                    location.pathname.split("/").includes("courses")
                      ? "active"
                      : ""
                  }`}
                >
                  <span className="menu-item__icon">
                    <svg
                      viewBox="0 0 18 20"
                      fill={
                        location.pathname.split("/").includes("courses")
                          ? "#000"
                          : "#fff"
                      }
                      xmlns="http://www.w3.org/2000/svg"
                      className="menu-icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <path d="M16.75 19.5h-4.5c-.69 0-1.25-.56-1.25-1.25v-4.5a1 1 0 00-1-1H8a1 1 0 00-1 1v4.5c0 .69-.56 1.25-1.25 1.25h-4.5C.56 19.5 0 18.94 0 18.25V8.707C0 7.556.527 6.47 1.43 5.76L8.535.16a.752.752 0 01.928 0l7.107 5.6A3.75 3.75 0 0118 8.706v9.544c0 .69-.56 1.25-1.25 1.25z"></path>
                    </svg>
                  </span>
                  <div class="menu-item__label">
                    My Courses {courseNotifications?.length > 0 && <span className="badge">New</span>}
                  </div>
                </Link>
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(updateRenderChats(true));
                    navigate("/content-library");
                  }}
                  className={`menu-item ${
                    location.pathname === "/content-library" ? "active" : ""
                  }`}
                >
                  <span className="menu-item__icon">
                    <svg
                      viewBox="0 0 22 22"
                      fill={
                        location.pathname === "/content-library"
                          ? "#000"
                          : "#fff"
                      }
                      xmlns="http://www.w3.org/2000/svg"
                      className="menu-icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <path d="M13.25.5C12.01.5 11 1.51 11 2.75v.5h2.5c1.251 0 2.337.712 2.88 1.75h1.87a.75.75 0 010 1.5h-1.5V8h1.5a.75.75 0 010 1.5h-1.5V14h2.5c1.24 0 2.25-1.01 2.25-2.25v-9C21.5 1.51 20.49.5 19.25.5h-6zM7.5 4.25c-1.24 0-2.25 1.01-2.25 2.25V7h1.5v-.5a.75.75 0 01.75-.75h6a.75.75 0 01.75.75v9a.75.75 0 01-.75.75H12v1.5h1.5c1.24 0 2.25-1.01 2.25-2.25v-9c0-1.24-1.01-2.25-2.25-2.25h-6zM2.75 8C1.51 8 .5 9.01.5 10.25v9c0 1.24 1.01 2.25 2.25 2.25h6c1.24 0 2.25-1.01 2.25-2.25v-9C11 9.01 9.99 8 8.75 8h-6zm1 4.5h4a.75.75 0 010 1.5h-4a.75.75 0 010-1.5zm0 3h4a.75.75 0 010 1.5h-4a.75.75 0 010-1.5z"></path>
                    </svg>
                  </span>
                  <div class="menu-item__label">Content Library</div>
                </Link>
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(updateRenderChats(true));
                    navigate("/groups");
                  }}
                  className={`menu-item ${
                    location.pathname.split("/").includes("groups")
                      ? "active"
                      : ""
                  }`}
                >
                  <span className="menu-item__icon">
                    <svg
                      viewBox="0 0 19 20"
                      fill={
                        location.pathname.split("/").includes("groups")
                          ? "#000"
                          : "#fff"
                      }
                      xmlns="http://www.w3.org/2000/svg"
                      className="menu-icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <path d="M6 7.5C4.07 7.5 2.5 5.93 2.5 4S4.07.5 6 .5 9.5 2.07 9.5 4 7.93 7.5 6 7.5zm0-5c-.827 0-1.5.673-1.5 1.5S5.173 5.5 6 5.5 7.5 4.827 7.5 4 6.827 2.5 6 2.5zm8-2a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM8.174 16.409A3.234 3.234 0 016 17.25 3.254 3.254 0 012.75 14v-3.75H8c0-.788.335-1.498.868-2H2.75c-1.103 0-2 .897-2 2V14A5.256 5.256 0 006 19.25a5.218 5.218 0 002.997-.945 5.961 5.961 0 01-.823-1.896zM17.25 8.5h-6.5C9.785 8.5 9 9.285 9 10.25V15c0 2.757 2.243 5 5 5s5-2.243 5-5v-4.75c0-.965-.785-1.75-1.75-1.75z"></path>
                    </svg>
                  </span>
                  <div class="menu-item__label">
                    Groups {groupNotifications?.length > 0 && <span className="badge">New</span>}
                  </div>
                </Link>
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(clearNotification());
                    navigate("/chat");
                  }}
                  className={`menu-item ${
                    location.pathname === "/chat" ? "active" : ""
                  }`}
                >
                  <span className="menu-item__icon">
                    <svg
                      viewBox="0 0 19 20"
                      fill={location.pathname === "/chat" ? "#000" : "#fff"}
                      xmlns="http://www.w3.org/2000/svg"
                      className="menu-icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <path d="M3.25 0A3.254 3.254 0 000 3.25v11.018a1.246 1.246 0 001.251 1.25c.259 0 .516-.08.734-.239L6.493 12h6.257A3.254 3.254 0 0016 8.75v-5.5A3.254 3.254 0 0012.75 0h-9.5zM17 4.01v4.74A4.253 4.253 0 0112.75 13H6.82l-2.225 1.615A3.245 3.245 0 007.25 16h6.255l4.51 3.28a1.242 1.242 0 001.3.1c.425-.21.685-.64.685-1.11V7.25a3.258 3.258 0 00-3-3.24z"></path>
                    </svg>
                  </span>
                  <div class="menu-item__label">
                    Chats {notifications?.length > 0 && <span className="badge">New</span>}
                  </div>
                </Link>
                {isAdmin && (
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(updateRenderChats(true));
                      navigate("/campaigns");
                    }}
                    className={`menu-item ${
                      location.pathname.split("/").includes("campaigns")
                        ? "active"
                        : ""
                    }`}
                  >
                    <span className="menu-item__icon">
                      <svg
                        viewBox="0 0 19 20"
                        fill={
                          location.pathname.split("/").includes("campaigns")
                            ? "#000"
                            : "#fff"
                        }
                        xmlns="http://www.w3.org/2000/svg"
                        className="menu-icon__svg"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M18 15.063c0 1.187-1.5 2.687-2.688 2.687H2.688C1.5 17.75 0 16.25 0 15.063V7.807c0-.256 0-1.389.17-1.738C.325 5.75 1.3 4.909 1.5 4.75c.408-.32.598-.453 1.106-.81A287.43 287.43 0 006.42 1.206C7.011.776 8.184.237 9 .25c.816-.012 1.99.526 2.58.957.561.407 1.044.756 1.462 1.057a.314.314 0 00-.317.082l-.942.941a.314.314 0 10.444.444l.941-.941a.313.313 0 00.038-.408c1.14.82 1.77 1.264 2.188 1.557.508.358.698.492 1.106.811.201.158 1.175 1 1.33 1.319.17.35.17 1.482.17 1.738v7.256zM15.691 9.15a.281.281 0 00-.398-.067c-.803.593-1.95 1.431-3.712 2.71-.1.072-.215.162-.343.26-.633.49-1.56 1.207-2.238 1.196-.679.01-1.604-.705-2.237-1.195-.128-.099-.244-.189-.344-.261a580.72 580.72 0 01-3.712-2.71.281.281 0 00-.398.067l-.32.464a.281.281 0 00.065.386c.805.594 1.95 1.43 3.702 2.702.109.079.23.173.362.275.738.57 1.817 1.405 2.882 1.397 1.065.008 2.143-.826 2.881-1.397.133-.102.254-.196.363-.275A588.126 588.126 0 0015.946 10a.281.281 0 00.064-.386l-.319-.464zm-3.058-3.76a.314.314 0 00.314.314h1.57a.314.314 0 100-.627h-1.57a.314.314 0 00-.313.314zm-.849 2.105l.941.941a.314.314 0 00.444-.443l-.941-.942a.314.314 0 00-.444.444zM10.85 4.98h-.314V3.287c0-.418-.491-.66-.849-.444a8.177 8.177 0 01-3.482 1.145.45.45 0 00-.326.17 1.856 1.856 0 00-.363 1.136c-.008.41.121.81.363 1.137a.45.45 0 00.326.17 8.178 8.178 0 013.482 1.145c.358.216.85-.027.85-.445V5.608h.313a.314.314 0 100-.627zM5.815 7.51a.514.514 0 00-.455-.332 4.899 4.899 0 00-.159-.001.473.473 0 00-.44.667l.005.012c.343.683.581 1.413.708 2.167.015.163.15.288.314.292H6.4a.317.317 0 00.243-.114.303.303 0 00.069-.25 7.52 7.52 0 00-.636-1.84 17.115 17.115 0 01-.261-.601zM4.368 4.039H4.26a1.253 1.253 0 00-.181 2.49l.031.005c.05.008.1.013.15.015h.108c.378 0 .628-.412.562-.783a2.672 2.672 0 010-.943c.066-.372-.184-.784-.562-.784z"
                        ></path>
                      </svg>
                    </span>
                    <div class="menu-item__label">Drip Campaign</div>
                  </Link>
                )}
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(updateRenderChats(true));
                    navigate("/calendar");
                  }}
                  className={`menu-item ${
                    location.pathname === "/calendar" ? "active" : ""
                  }`}
                >
                  <span className="menu-item__icon">
                    <svg
                      viewBox="0 0 19 20"
                      fill={location.pathname === "/calendar" ? "#000" : "#fff"}
                      xmlns="http://www.w3.org/2000/svg"
                      className="menu-icon__svg"
                      preserveAspectRatio="xMidYMid meet"
                    >
                      <path d="M18 4v-.75A3.254 3.254 0 0014.75 0H3.25A3.254 3.254 0 000 3.25V4h18zM0 5.5v9.25A3.254 3.254 0 003.25 18h11.5A3.254 3.254 0 0018 14.75V5.5H0zM4.75 15a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm0-4.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM9 15a1.25 1.25 0 110-2.5A1.25 1.25 0 019 15zm0-4.5A1.25 1.25 0 119 8a1.25 1.25 0 010 2.5zm4.25 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"></path>
                    </svg>
                  </span>
                  <div class="menu-item__label">Calendar Of Events</div>
                </Link>
                {userDetails && userDetails.admin && (
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(updateRenderChats(true));
                      navigate("/users");
                    }}
                    className={`menu-item ${
                      location.pathname === "/users" ? "active" : ""
                    }`}
                  >
                    <span className="menu-item__icon">
                      <svg
                        viewBox="0 0 19 20"
                        fill={location.pathname === "/users" ? "#000" : "#fff"}
                        xmlns="http://www.w3.org/2000/svg"
                        className="menu-icon__svg"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <path d="M21.98 6.861a.463.463 0 00-.785-.285L18.6 9.16l-2.877-.908-.91-2.865 2.594-2.586a.458.458 0 00-.287-.782 5.342 5.342 0 00-4.236 1.537 5.312 5.312 0 00-1.217 5.645 3.914 3.914 0 00-.232.21l-8.662 8.143-.009.009a2.6 2.6 0 000 3.681 2.608 2.608 0 003.695-.025l8.102-8.696c.074-.074.143-.152.207-.231a5.362 5.362 0 005.669-1.211 5.3 5.3 0 001.543-4.22zM5.141 20.15a.963.963 0 01-1.358 0 .954.954 0 010-1.354.964.964 0 011.358 0 .954.954 0 010 1.354z"></path>
                      </svg>
                    </span>
                    <div class="menu-item__label">User Management</div>
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div
            className="sidebar__footer"
            ref={dropdownRef}
            onClick={toggleDropdown}
          >
            <span className="sidebar__dropdown">
              <div className="sidebar-dropdown-activator">
                <div className="sidebar__footer-activator">
                  <div
                    className="sidebar__avatar"
                    style={{
                      backgroundColor: getColorFromName(userDetails?.name),
                    }}
                  >
                    {currentUserData && currentUserData.image ? (
                      <img
                        className="avatar__image"
                        src={currentUserData.image}
                        alt="User Avatar"
                      />
                    ) : (
                      <div className="user__avatar">
                        {userDetails?.name.substr(0, 1)}
                      </div>
                    )}
                  </div>
                  <div className="sidebar__footer-content">
                    <div class="sidebar-heading">
                      {currentUserData
                        ? currentUserData?.name?.split(" ")[0]
                        : ""}
                    </div>
                    <div className="icon-settings">
                      <svg
                        viewBox="0 0 20 20"
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon__svg"
                        preserveAspectRatio="xMidYMid meet"
                        style={{ width: "20px", height: "20px" }}
                      >
                        <path
                          d="M17.57 11.14a1.399 1.399 0 01-.57-1.123c0-.443.213-.863.569-1.124l1.647-1.208a.751.751 0 00.268-.842 9.937 9.937 0 00-1.993-3.454.752.752 0 00-.864-.19l-1.854.815a1.398 1.398 0 01-1.258-.069 1.398 1.398 0 01-.689-1.054L12.603.855a.751.751 0 00-.595-.654A10.074 10.074 0 008.023.196a.75.75 0 00-.598.654l-.221 2.023a1.397 1.397 0 01-1.947 1.124l-1.864-.82a.75.75 0 00-.863.189A9.932 9.932 0 00.526 6.814a.75.75 0 00.267.844l1.637 1.2A1.4 1.4 0 013 9.982c0 .443-.213.863-.569 1.124L.784 12.313a.751.751 0 00-.269.842A9.937 9.937 0 002.51 16.61a.75.75 0 00.864.19l1.854-.816a1.398 1.398 0 011.258.07c.383.22.64.615.689 1.054l.223 2.036a.751.751 0 00.595.654 10.064 10.064 0 003.984.004.75.75 0 00.598-.654l.222-2.023a1.397 1.397 0 011.947-1.124l1.865.82a.749.749 0 00.862-.189 9.932 9.932 0 002.004-3.448.75.75 0 00-.268-.843l-1.636-1.2zM10 13.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z"
                          fill="#fff"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              {dropdownOpen && (
                <div className="sidebar-dropdown-popover">
                  <div className="sidebar-dropdown-content">
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(updateRenderChats(true));
                        navigate("/settings");
                      }}
                      className="sidebar-dropdown-item"
                    >
                      <span className="icon-settings">
                        <svg
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon__svg"
                          preserveAspectRatio="xMidYMid meet"
                          style={{ width: "20px", height: "20px" }}
                        >
                          <path
                            d="M17.57 11.14a1.399 1.399 0 01-.57-1.123c0-.443.213-.863.569-1.124l1.647-1.208a.751.751 0 00.268-.842 9.937 9.937 0 00-1.993-3.454.752.752 0 00-.864-.19l-1.854.815a1.398 1.398 0 01-1.258-.069 1.398 1.398 0 01-.689-1.054L12.603.855a.751.751 0 00-.595-.654A10.074 10.074 0 008.023.196a.75.75 0 00-.598.654l-.221 2.023a1.397 1.397 0 01-1.947 1.124l-1.864-.82a.75.75 0 00-.863.189A9.932 9.932 0 00.526 6.814a.75.75 0 00.267.844l1.637 1.2A1.4 1.4 0 013 9.982c0 .443-.213.863-.569 1.124L.784 12.313a.751.751 0 00-.269.842A9.937 9.937 0 002.51 16.61a.75.75 0 00.864.19l1.854-.816a1.398 1.398 0 011.258.07c.383.22.64.615.689 1.054l.223 2.036a.751.751 0 00.595.654 10.064 10.064 0 003.984.004.75.75 0 00.598-.654l.222-2.023a1.397 1.397 0 011.947-1.124l1.865.82a.749.749 0 00.862-.189 9.932 9.932 0 002.004-3.448.75.75 0 00-.268-.843l-1.636-1.2zM10 13.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z"
                            fill="#D3D7DA"
                          ></path>
                        </svg>
                      </span>
                      <span className="dropdown-item-label">
                        Account settings
                      </span>
                    </Link>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(updateRenderChats(true));
                        navigate("/journal");
                      }}
                      className="sidebar-dropdown-item"
                    >
                      <span className="icon-settings">
                        <NotebookPen
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "#D3D7DA",
                          }}
                        />
                      </span>
                      <span className="dropdown-item-label">Edit Journal</span>
                    </Link>
                    <button
                      onClick={handleLogout}
                      className="sidebar-dropdown-item"
                    >
                      <span className="icon-settings">
                        <svg
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="icon__svg"
                          preserveAspectRatio="xMidYMid meet"
                          style={{ width: "20px", height: "20px" }}
                        >
                          <path
                            d="M3 0C1.355 0 0 1.355 0 3v12c0 1.645 1.355 3 3 3h8.5c1.388 0 2.623-.91 2.969-2.251a1 1 0 00-1.938-.498c-.099.384-.555.749-1.031.749H3c-.564 0-1-.436-1-1V3c0-.564.436-1 1-1h8.5c.476 0 .932.365 1.031.749a1.002 1.002 0 001.57.55 1 1 0 00.368-1.048C14.124.91 12.888 0 11.5 0H3zm10.99 4.99a1 1 0 00-.697 1.717L14.586 8H5.5a1 1 0 100 2h9.086l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 00-.718-.303z"
                            fill="#D3D7DA"
                          ></path>
                        </svg>
                      </span>
                      <span className="dropdown-item-label">Logout</span>
                    </button>
                  </div>
                </div>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
